import React from "react";
import { faReact, faDocker, faPython, faMicroblog } from '@fortawesome/free-brands-svg-icons';
import '../assets/styles/Volunteering.scss';


function Volunteering() {
    return (
    <div className="container" id="volunteering">
        <div className="skills-container">
            <h1>Volunteering</h1>
                <div className="skills-grid">
                    <div className="skill-inset">
                        <div className="skill-left">
                            <a href="https://www.roteskreuz.at/home" target="_blank" rel="noreferrer"><img src={require('../assets/images/red_cross.png')} alt="Red Cross" className="zoom_volunteer"/></a>
                        </div>
                        <div className="skill-right">
                            <h2>Paramedic at Red Cross Austria</h2>
                            <p>
                                I volunteered with the Red Cross Austria as a paramedic, helping with emergency responses and transporting elderly people and others in need. My role involved providing basic medical assistance and ensuring safe transport for those who required it.
                            </p>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    );
}

export default Volunteering;